import { isHttpClientError, type HttpClientError } from "@/shared/http";
import { getCurrentMe } from "../api/intakeMeApi";
import type { IntakeMembership } from "../domain/authSession";

// `GET /v1/me` 결과의 세 갈래. 세션을 살릴지 끝낼지는 호출자(로그인 콜백 · 복원)가 정한다 — 거부와 미확인을
// 같은 실패로 접으면 BE 가 잠시 죽었을 때 열린 탭이 모두 로그아웃된다.
export type MembershipResolution =
  | { kind: "member"; membership: IntakeMembership }
  // Intake 가 이 토큰·계정을 거부했다 — 401(토큰 무효·만료) 또는 403(Member 미등록 `member.not_found` ·
  // 회수 `member.inactive`). 세션을 끝내야 한다.
  | { kind: "rejected"; code: string | null; error: HttpClientError }
  // Intake 에 닿지 못했거나(네트워크 · timeout · 5xx · 503 JWKS) 응답이 계약과 달랐다. 거부가 아니라 미확인이다.
  | { kind: "unavailable"; error: unknown };

export async function resolveIntakeMembership(): Promise<MembershipResolution> {
  try {
    return { kind: "member", membership: await getCurrentMe() };
  } catch (error) {
    if (isHttpClientError(error) && (error.status === 401 || error.status === 403)) {
      return { kind: "rejected", code: error.code, error };
    }

    return { kind: "unavailable", error };
  }
}
